import { createYmaps } from 'vue-yandex-maps';

import type { CustomElementOptions } from 'vue';
import type { Router, RouterMatcher } from 'vue-router';

type App = Parameters<NonNullable<CustomElementOptions['configureApp']>>[0];

export const initPlugins = (app: App, _router: Router, _matcher: RouterMatcher) => {
  void _router;
  void _matcher;

  app.use(
    createYmaps({
      apikey: import.meta.env.VITE_YANDEX_MAP_KEY ?? '05f23d6d-b09f-48e8-824f-67143f7e0de6',
    }),
  );
};
